import { combineReducers } from 'redux';
import entities from './entitiesReducer';
import * as entitiesReducer from './entitiesReducer';
import orders from './ordersReducer';
import * as ordersReducer from './ordersReducer';

const rootReducer = combineReducers({
  entities,
  orders
});

export default rootReducer;

export const getOrdersByStatus = (state, status) => {
  const orderIds = ordersReducer.getIdsByStatus(state.orders, status);
  return entitiesReducer.getOrders(state.entities, orderIds);
};

export const getOrder = (state, orderId) => {
  return entitiesReducer.getOrder(state.entities, orderId);
};



// WEBPACK FOOTER //
// ./src/reducers/index.js